import { create } from 'zustand'
import { TemplateListItem } from '@/types/templates';
import { nanoid } from 'nanoid';

type TemplateFilters = {
  search: string;
  type: string;
  creator: string;
  state: string;
  matterType: string[];
}

type PromptTemplatesStore = {
  promptTemplates: (TemplateListItem & { currentUserCreated: boolean })[];
  isLoadingRunTemplate: boolean;
  isLoadingGetTemplates: boolean;
  promptTemplateSelected: { id: string; requestDocument: boolean } | null;
  initialTemplateId: string | null;
  pollForTemplateChangesOnRefocus: boolean;
  forceRefresh: string;
  filters: TemplateFilters;
  // FOO
  mergeTemplateWithPromptTemplates: (template: TemplateListItem & { currentUserCreated: boolean }) => void;
  deleteFromPromptTemplates: (templateId: string) => void;
  setPromptTemplates: (promptTemplates: (TemplateListItem & { currentUserCreated: boolean })[]) => void;
  setIsLoadingRunTemplate: (isLoadingRunTemplate: boolean) => void;
  setIsLoadingGetTemplates: (isLoadingGetTemplates: boolean) => void;
  setPromptTemplateSelected: (promptTemplateSelected: { id: string; requestDocument: boolean } | null) => void;
  setInitialTemplateId: (initialTemplateId: string | null) => void;
  setPollForTemplateChangesOnRefocus: (pollForTemplateChangesOnRefocus: boolean) => void;
  setForceRefresh: () => void;
  setFilters: (filters: Partial<TemplateFilters>) => void;
  setMatterTypeFilter: (matterTypeId: string | null) => void;
  // BAR
}

// Helper function to get initial matter type filter
const getInitialMatterTypeFilter = (matterTypeId?: string | null): string[] => {
  return matterTypeId ? [matterTypeId] : ['all'];
}

// INPUT

export const usePromptTemplatesStore = create<PromptTemplatesStore>((set, get) => ({
  promptTemplates: [],
  isLoadingRunTemplate: false,
  isLoadingGetTemplates: true,
  promptTemplateSelected: null,
  initialTemplateId: null,
  pollForTemplateChangesOnRefocus: false,
  forceRefresh: '',
  filters: {
    search: '',
    type: 'all',
    creator: 'all',
    state: 'all',
    matterType: ['all'] // Will be updated when matter loads
  },
  // BAZ
  setPromptTemplates: (promptTemplates) => set({ promptTemplates }),
  mergeTemplateWithPromptTemplates: (template) => set({ 
    promptTemplates: [
      ...get().promptTemplates.filter(({ id }) => id !== template.id),
      template
    ]
  }),
  deleteFromPromptTemplates: (templateId) => set({ 
    promptTemplates: get().promptTemplates.filter(t => t.id !== templateId)
  }),
  setIsLoadingRunTemplate: (isLoadingRunTemplate) => set({ isLoadingRunTemplate }),
  setIsLoadingGetTemplates: (isLoadingGetTemplates) => set({ isLoadingGetTemplates }),
  setPromptTemplateSelected: (promptTemplateSelected) => set({ promptTemplateSelected }),
  setInitialTemplateId: (initialTemplateId) => set({ initialTemplateId }),
  setPollForTemplateChangesOnRefocus: (pollForTemplateChangesOnRefocus) => set({ pollForTemplateChangesOnRefocus }),
  setForceRefresh: () => set({ forceRefresh: nanoid() }),
  setFilters: (filters) => set((state) => ({ filters: { ...state.filters, ...filters } })),
  setMatterTypeFilter: (matterTypeId) => set((state) => ({ 
    filters: { 
      ...state.filters, 
      matterType: getInitialMatterTypeFilter(matterTypeId) 
    }
  })),
  //QUX
}));
